import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import logoBlack from '@/assets/images/upstack-data-black.svg';
import logoWhite from '@/assets/images/upstack-data-white.svg';
import { cn } from '@/lib/utils';

export interface AppTopbarProps {
  actions?: ReactNode;
  logoLinked?: boolean;
  className?: string;
}

export function AppTopbar({ actions, logoLinked = true, className }: AppTopbarProps) {
  const logo = (
    <>
      <img
        src={logoBlack}
        alt="Upstack Data"
        width={120}
        height={20}
        className="h-5 w-auto dark:hidden"
        loading="eager"
      />
      <img
        src={logoWhite}
        alt="Upstack Data"
        width={120}
        height={20}
        className="hidden h-5 w-auto dark:block"
        loading="eager"
      />
    </>
  );

  return (
    <header
      className={cn(
        'header-gradient sticky top-0 z-sticky h-12 border-b border-border/80 backdrop-blur-xl',
        className,
      )}
    >
      <div className="mx-auto flex h-full w-full max-w-6xl items-center justify-between border-x border-border px-4 sm:px-6 lg:px-8">
        {logoLinked ? (
          <Link to="/" className="flex items-center text-foreground no-underline">
            {logo}
          </Link>
        ) : (
          <div className="flex items-center">{logo}</div>
        )}

        {actions ? <div className="flex items-center gap-1.5">{actions}</div> : null}
      </div>
    </header>
  );
}
